import type { CarrierPricings } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useCarrierPricingsCoverageImpact(shopId: string) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/carriers/{carrierId}/pricings/coverage-impact",
		{
			notify: false,
			mapVariables: ({
				carrierId,
				pricings,
			}: {
				carrierId: string;
				pricings: CarrierPricings[];
			}) => ({
				params: { path: { carrierId, shopId } },
				body: { pricings },
			}),
		},
	);
}
